import { FormattedMessage } from "react-intl";
import { ENGLISH_PARAMETER_NAME, GERMAN_LANGUAGE, GERMAN_PARAMETER_NAME } from "../common/constant";

export function getOptionParameterName(language) {
  return language === GERMAN_LANGUAGE ? GERMAN_PARAMETER_NAME : ENGLISH_PARAMETER_NAME;
}

export function getOptionListFromResult(language, result) {
  let languageParameter = getOptionParameterName(language);
  const optionList = [];
  if (result) {
    for (let i = 0; i < result.length; i++) {
      let newOption = {
        name: result[i].id,
        value: result[i].code,
        text: result[i][languageParameter]
      };
      optionList.push(newOption);
    }
  }

  return optionList.sort((a,b) => a.text.localeCompare(b.text));
}

export function getOptionTextFromValue(value, options) {
  if (value) {
    const option = options.find((option) => option.value === value);

    if (option) {
      return option.text;
    }
  }

  return "";
}

export function processCheckboxLabel(element) {
  return element.name?.length > 15
    ? `${element.name.substring(0, 4)}...${element.name.substring(element.name.length - 8, element.name.length)} `
    : element.name;
}

export function renderOptions(list, type, messageId, getOptionLabel) {
  return (
    <>
      <option value="">
        <FormattedMessage id={type} />
      </option>
      {[...new Set(list || [])].sort().map((e, i) => (
        <option key={i} value={e}>
          {messageId ? <FormattedMessage id={`${messageId}${e}`} /> : getOptionLabel ? getOptionLabel(e) : e}
        </option>
      ))}
    </>
  );
}
